import React from 'react';
import CheckBox from './common/CheckBox';

import arrow_right_icon from '../asset/img/common/arrow_right_icon.svg';
import arrow_right_999_icon from '../asset/img/common/arrow_right_999_icon.svg';

const CheckBoxWithArrow = ({ clickCheckHandler, check, handleCheckChange, label, name }) => {
  return (
    <div
      className="displayFlex"
      style={{ justifyContent: 'space-between' }}
      onClick={clickCheckHandler}>
      <CheckBox
        label={label}
        checked={check}
        onChange={handleCheckChange}
        variant="circle"
        size="regular"
        name={name}
      />
      <img
        src={check ? arrow_right_icon : arrow_right_999_icon}
        onClick={clickCheckHandler}
        alt="체크박스"
      />
    </div>
  );
};

export default CheckBoxWithArrow;
